module.exports = __webpack_public_path__ + "img/AdelleSAGE-Bold.bff9dc30.svg";